import type Insured from '@/modules/common/common/models/APP/Insured'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

import TravelSaveInsuredsRequest from '../../models/MID/requests/TravelSaveInsuredsRequest'

export default class SaveTravelMapper {
  static toRequest(quotationId: string, insureds: Insured[]): TravelSaveInsuredsRequest {
    const insuredsToSave: any[] = insureds.map((insured) => ({
      ...insured,
      riskNumber: insured.riskNumber,
      nacionality: insured.addressDetails.country,
      documentType: insured.documentDetails.documentType,
      documentNumber: insured.documentDetails.documentNumber,
      name: insured.userDetails.name,
      firstSurname: insured.userDetails.surname1,
      secondSurname: insured.userDetails.surname2,
      birthDate: insured.userDetails.birthDate
        ? CommonMapper.toMiddlewareDate(new Date(insured.userDetails.birthDate))
        : undefined,
      sex: insured.userDetails.gender,
      streetType: insured.addressDetails.streetType,

      street: insured.addressDetails.address,

      city: insured.addressDetails.city,

      house: insured.addressDetails.roadNumber,

      postalCode: insured.addressDetails.postalCode,

      province: insured.addressDetails.province,

      houseType: insured.addressDetails.houseType,

      gateway: insured.addressDetails.gateway,

      stair: insured.addressDetails.stair,

      floor: insured.addressDetails.floor,

      doorway: insured.addressDetails.doorway,

      restAddress: insured.addressDetails.addressExtra,

      addressNormalice: insured.addressDetails.addressNormalize,

      email: insured.userDetails.email,

      prefix: insured.userDetails.prefix,

      mobilePhone: insured.userDetails.phone,

      policyHolderConsent: insured.policyHolderConsent,
      documentExpirationDate: insured.documentDetails.documentExpirationDate
        ? CommonMapper.toMiddlewareDate(insured.documentDetails.documentExpirationDate)
        : undefined
    }))

    return new TravelSaveInsuredsRequest({
      quotationId,
      insureds: insuredsToSave
    })
  }
}
